import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { Box, IconButton, Tooltip } from '@mui/material';
import { RouteType, RouteWithDetailedView } from '../types';
import Icons from '../../../components/icons';
import { AlertButton } from '../styled';

export const getRoutesColumns = (
  onEdit: (route: RouteWithDetailedView) => void,
  onDelete: (route: RouteWithDetailedView) => void,
  onSendAlert: (route: RouteWithDetailedView) => void
): GridColDef[] => [
  { field: 'name', headerName: 'Route Name', minWidth: 200, flex: 1 },
  {
    field: 'departureBetween',
    headerName: 'Departure Between',
    minWidth: 200,
    flex: 1,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row?.departureWindow) {
        return '-';
      }
      return `${params.row.departureWindow.from} and ${params.row.departureWindow.to}`;
    }
  },
  {
    field: 'arrivalBetween',
    headerName: 'Arrival Between',
    minWidth: 200,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row) {
        return '-';
      }
      return params.row.arrivalWindow || '-';
    }
  },
  {
    field: 'totalStops',
    headerName: 'Total Stops',
    width: 120,
    type: 'number',
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row) {
        return 0;
      }
      return params.row.stops?.length || 0;
    }
  },
  {
    field: 'busName',
    headerName: 'Bus',
    width: 150,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row) {
        return '-';
      }
      return params.row.bus?.name || '-';
    }
  },
  {
    field: 'travelTime',
    headerName: 'Travel Time',
    width: 150,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row) {
        return '-';
      }
      return params.row.travelTime || '-';
    }
  },
  {
    field: 'routeType',
    headerName: 'Route Type',
    width: 150,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      if (!params.row) {
        return '-';
      }
      return params.row.type === RouteType.PICK_UP_ROUTE
        ? 'Pick up Route'
        : 'Drop Off Route';
    }
  },
  {
    field: 'edit',
    headerName: 'Actions',
    align: 'center',
    headerAlign: 'center',
    width: 100,
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      return (
        <Box>
          <Tooltip title='Edit'>
            <span>
              <IconButton
                size='small'
                onClick={() => onEdit(params.row)}
                aria-label='edit route'
                color='error'
              >
                <Icons.EditBlackOutlined />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title='Delete'>
            <span>
              <IconButton
                size='small'
                onClick={() => onDelete(params.row)}
                aria-label='delete bus'
                color='error'
              >
                <Icons.Delete />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      );
    }
  },

  {
    field: 'sosAlert',
    headerName: 'SOS Alert',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params: GridRenderCellParams<any, RouteWithDetailedView>) => {
      return (
        <AlertButton
          variant='contained'
          startIcon={<Icons.BusAlert />}
          onClick={() => onSendAlert(params.row)}
        >
          Send Alert
        </AlertButton>
      );
    }
  }
];
